/**
 * @ipc/validation · src/schemas/payments.ts — группа `/api/v1/payments`
 * (раздел 13, "schemas/payments.ts").
 */
import { z } from 'zod/v4';
import { tiyinAmount, paginationSchema, paymentStatusSchema, searchSchema, sortOrderSchema } from '../common/primitives.ts';
import { paymentServiceEnum } from '../enums/multicard.ts';

/** Колонки серверной сортировки списка платежей (GET /api/v1/payments). */
export const PAYMENT_SORT_COLUMNS = ['createdAt', 'amount', 'status'] as const;
export const paymentSortBySchema = z.enum(PAYMENT_SORT_COLUMNS);
export type PaymentSortBy = z.infer<typeof paymentSortBySchema>;

export const paymentFiltersSchema = paginationSchema.extend({
  status: paymentStatusSchema.optional(),
  service: paymentServiceEnum.optional(),
  merchantId: z.string().optional(),
  invoiceId: z.string().optional(),
  providerUuid: z.string().optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  amountFrom: tiyinAmount.optional(),
  amountTo: tiyinAmount.optional(),
  search: searchSchema,
  sortBy: paymentSortBySchema.default('createdAt'),
  sortOrder: sortOrderSchema,
});
export type PaymentFiltersDto = z.infer<typeof paymentFiltersSchema>;

/** PUT /api/v1/payments/:uuid/scanpay — быстрая оплата (PaymeGo/ClickPass). */
export const scanPaySchema = z.object({
  code: z.string().min(1),
});
export type ScanPayDto = z.infer<typeof scanPaySchema>;
